import Amplitude from 'amplitudejs';

const testUrlPodcast = 'https://anchor.fm/s/685a0ed4/podcast/play/44982702/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2021-11-17%2F8e23e95b-7227-3fda-cbc8-e5a40a3ff3f0.mp3';

// Получаем данные подкаста
let songs = [];
const podcastTemplate = $('.hh-podcast-player');

podcastTemplate.each((index, element) => {
    songs.push({
        'title': $(element).data('hhPodcastTitle'),
        'url': $(element).data('hhPodcastFile'),
    });
});

Amplitude.init({
    "bindings": {
        37: 'prev',
        39: 'next',
        32: 'play_pause'
    },
    "songs": songs,
});

$('.hh-podcast-player__progress').on('click', function(e) {
    var offset = this.getBoundingClientRect();
    var x = e.pageX - offset.left;

    Amplitude.setSongPlayedPercentage(( parseFloat(x) / parseFloat(this.offsetWidth)) * 100);
});